import React, { useCallback } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import ModalDialog from '../../../common/components/ModalDialog';
import { useSnapshot } from 'valtio';
import { setSavePoliciesInProgress } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import { LoadingButton } from '@mui/lab';
import CustomTooltip from '../../../common/components/CustomTooltip';
import ProfileStore from '../../store/profiles';
import updateProfileByIdAction from '../../actions/profiles-actions/save-profile-action';
import { cancelProfilePoliciesChanges } from '../../actions/policies-profile-actions/policy-state-actions';

const UnSavedProfileChangesModal: React.FC<
  React.PropsWithChildren<UnSavedProfileChangesModalProps>
> = ({ cancelNavigation, confirmNavigation, open, savePoliciesInProgress }) => {
  const { profileInContext } = useSnapshot(ProfileStore);

  const saveChangesHandler = useCallback(async () => {
    setSavePoliciesInProgress(true);
    await updateProfileByIdAction();
    confirmNavigation();
  }, [confirmNavigation]);

  const cancelChangesHandler = useCallback(async () => {
    cancelProfilePoliciesChanges();
    confirmNavigation();
  }, [confirmNavigation]);

  return (
    <ModalDialog
      aria-label='Unsaved Changes'
      open={open}
      onClose={cancelNavigation}
      modalHeader='Unsaved Changes'>
      <Box
        display='flex'
        justifyContent='space-between'
        flexDirection='column'
        gap={2}>
        {profileInContext && (
          <Typography lineHeight={2} color='info' variant='body2'>
            You have unsaved changes for proflie "{profileInContext.profileName}
            "!
          </Typography>
        )}
        <Stack
          justifyContent='flex-end'
          alignItems='flex-start'
          direction='row'
          spacing={1}>
          <CustomTooltip title='Continue without saving'>
            <span>
              <LoadingButton
                variant='outlined'
                loadingPosition='center'
                size='small'
                color='secondary'
                onClick={cancelChangesHandler}>
                Cancel
              </LoadingButton>
            </span>
          </CustomTooltip>
          <CustomTooltip title='Save changes'>
            <span>
              <LoadingButton
                variant='outlined'
                loading={savePoliciesInProgress}
                loadingPosition='center'
                size='small'
                color='primary'
                onClick={saveChangesHandler}>
                Save
              </LoadingButton>
            </span>
          </CustomTooltip>
        </Stack>
      </Box>
    </ModalDialog>
  );
};

interface UnSavedProfileChangesModalProps {
  open: boolean;
  cancelNavigation: () => void;
  confirmNavigation: () => void;
  savePoliciesInProgress: boolean;
}

export default UnSavedProfileChangesModal;
